import {ngAsync} from 'shared/utils/ng-@decorators';
import type {Transaction} from './types';
import type {AjaxService} from 'core/data-services/ajax.service';

/**
 * @ngdoc service
 * @name transactionDataService
 * @module portaro.uc.user
 *
 *
 * @description
 * Data service for providing user transactions
 */
export default class TransactionDataService {
    public static readonly serviceName = 'transactionDataService';
    public static readonly ROUTE = 'transactions';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async query(ownerId: number): Promise<Transaction[]> {
        return this.ajaxService
            .createRequest(TransactionDataService.ROUTE)
            .get<Transaction[]>({owner: ownerId});
    }


    @ngAsync()
    public async remove(transactionId: number): Promise<void> {
        return this.ajaxService
            .createRequest(`${TransactionDataService.ROUTE}/${transactionId}`)
            .delete();
    }
}
